import React, { useState, useEffect } from "react";
import styles from "./SubProyectoItem.module.scss";
import { ReactComponent as Edit } from "../../../../../assets/svg/editarSkill.svg"
import { ReactComponent as Delete } from "../../../../../assets/svg/description-sub.svg"
import { connect } from "react-redux";
import { setEditSendSubProject, updateSubCotizacion } from "../../../../../store/actions/index";
import { updateSubProject, deleteSubProjects } from "../../../../../store/actions/profileActions"
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { ReactComponent as Description } from "../../../../../assets/svg/addDescriptionPlaceholder.svg";
import { ReactComponent as Link } from "../../../../../assets/svg/linkPlaceholder.svg";
import { ReactComponent as Upload } from "../../../../../assets/svg/upload-sub.svg";
import { ReactComponent as Alert } from "../../../../../assets/svg/alert-sub.svg";
import { checkDisabled } from "../../../../../utils/utilsFunctions";
import { ReactComponent as Date } from "../../../../../assets/svg/locationIcon.svg";
import { ReactComponent as Trash } from "../../../../../assets/svg/description-sub.svg";
import { useHistory } from "react-router-dom";



const SubProyectoItem = ({
  subProjectSubId,
  updateSubProject,
  deleteSubProjects,
  subProjectId,
  subProjectEdit,
  projectIdForSub,
  subProjectsToEdit,
  projectToEditId,
  ...props }) => {
  const [open, openHandler] = useState(false);
  const [fileName, fileNameHandler] = useState("");
  const [file, setFile] = useState('')
  const [isDateInput, setIsDateInput] = useState(false);
  const [subProject, setSubProject] = useState(props.subproject);
  const [subProjectIdEdit, setSubProjectIdEdit] = useState(props.subproject.id);
  const history = useHistory();

  useEffect(() => {
    if (props && props.subproject && props.subproject.budget_payroll || props.subproject.quotation_payroll) {
      try {
        const url = URL.createObjectURL(props.subproject.budget_payroll || props.subproject.quotation_payroll)
        setFile(url)
      } catch (error) {
        setFile(props.subproject.budget_payroll || props.subproject.quotation_payroll)
      }

    }
  }, [props])

  props.subproject.endDate = props.subproject?.endDate?.split("T")[0];
  props.subproject.startDate = props.subproject?.startDate?.split("T")[0];

  const placeholderFile = props.subproject.plantillaDePresupuesto?.name ? props.subproject.plantillaDePresupuesto.name : 'Adjuntar planilla de cotización'

  const editHandler = (values) => {

    const data = {
      id: parseInt(props.subproject.id) || parseInt(subProjectId),
      name: props.subproject.name,
      description: values.description,
      budget: values.file,
      link: values.link,
      endDate: values.endDate,
      startDate: values.startDate,
      history
    }
    updateSubProject(data, parseInt(projectToEditId));
    setSubProject(data);
    openHandler(!open);
  };

  useEffect(() => {
    setSubProject(subProject ? subProject : props.subproject);
  }, [subProject, props.subproject]);


  const deleteSubProjectHandler = () => {
    deleteSubProjects(parseInt(props.subproject.id || subProjectId), projectToEditId);
  };

  //VALIDACIONES
  const subProyectosSchema = Yup.object().shape({
    descriptionEdit: Yup.string().required("El campo es requerido"),

    linkEdit: Yup.string().required("El campo es requerido"),

    cierreEdit: Yup.date().required("El campo es requerido"),
  });

  return (
    <div className={`${styles.proyectItem} ${open ? styles.open : ""}`}>
      <div
        className={`${styles.proyectActions} ${props.subproject.finished ? styles.finished : ""}`}
        onClick={() => {
          openHandler(!open);
        }}
      >
        <p className={`${styles.description} ${open ? styles.open : ""}`}>
          {props.subproject.name} {props.subproject.status === "OPEN" ? "| ABIERTO" : ""}
        </p>
        <div className={`${styles.iconContainer} ${open ? styles.iconContainer_openEditText : ""}`}>
          <div className={styles.editContainer}>
            <p>editar</p>
            <div className={`${styles.iconEdit} ${open ? styles.iconEdit_open : ""}`}>
              <Edit />
            </div>
          </div>
          <div className={styles.borderIconDelete} onClick={(e) => {
            e.stopPropagation();
            deleteSubProjectHandler()
          }}>
            <p>eliminar</p>
            <div className={`${styles.iconDelete} ${open ? styles.iconDelete_open : ""}`}  >
              <Delete />
            </div>
          </div>
        </div>
      </div>
      <div className={styles.proyectInput}>
        {open ? (
          <Formik
            initialValues={{
              description: props.subproject.description === "undefined" ? "" : subProject.description !== props.subproject.description ? subProject.description : props.subproject.description,
              link: props.subproject.link === "undefined" ? "" : subProject.link !== props.subproject.link ? subProject.link : props.subproject.link,
              startDate: props.subproject.startDate === undefined ? "" : subProject.startDate !== props.subproject.startDate ? subProject.startDate : props.subproject.startDate,
              endDate: props.subproject.endDate === undefined ? "" : subProject.endDate !== props.subproject.endDate ? subProject.endDate : props.subproject.endDate,
              file: props.subproject.plantillaDePresupuesto ? "" : props.subproject.plantillaDePresupuesto || subProject.plantillaDePresupuesto,
            }}
            validationSchema={subProyectosSchema}
          >

            {({ handleSubmit, values, initialValues, setFieldValue }) => (
              <Form onSubmit={handleSubmit} className={`${styles.formContainer} ${open ? styles.open : ""}`}>
                <div className={styles.fieldWrapper_descriptionHeader}>
                  <Description />
                  <p>Descripción</p>
                </div>
                <div className={styles.fieldWrapper}>
                  <Field id='description' name='description' placeholder='Carga una breve descripción' as='textarea' />
                </div>
                <div className={styles.fieldWrapper_linkHeader}>
                  <Link />
                  <p>Link de accéso a documentación</p>
                </div>
                <div className={styles.fieldWrapper}>
                  <Field id='link' name='link' placeholder='Google Drive, Dropbox, etc.' />
                </div>
                <div className={styles.fieldWrapper_container}>
                  <div className={styles.fieldWrapper_dateHeaderText}>
                  <div className={styles.fieldWrapper_dateHeaderText_iconContainer}>
                    <Date width={15} height={15} />
                    <p>Fecha de inicio de ofertas</p>
                    </div>
                    <div className={styles.fieldWrapper}>
                      {props.subproject.startDate === undefined ? (
                        <Field type={isDateInput ? "date" : "text"} id='startDate' name='startDate' placeholder="Seleccione una fecha" value={values.startDate} onClick={() => setIsDateInput(true)} />)
                        : (<Field type="date" id='startDate' name='startDate' />)}
                    </div>
                  </div>
                  <div className={styles.fieldWrapper_dateHeaderText}>
                  <div className={styles.fieldWrapper_dateHeaderText_iconContainer}>
                    <Date width={15} height={15} />
                    <p>Fecha de cierre de ofertas</p>
                    </div>
                    <div className={styles.fieldWrapper}>
                      {props.subproject.endDate === undefined ? (
                        <Field type={isDateInput ? "date" : "text"} id='endDate' name='endDate' placeholder="Seleccione una fecha" value={values.endDate} onClick={() => setIsDateInput(true)} />)
                        : (<Field type="date" id='endDate' name='endDate' />)}
                    </div>
                  </div>
                </div>
                <div className={styles.fieldWrapper_fileHeader}>
                  <Upload />
                  <p>Planilla modelo de cotización</p>
                </div>
                <div className={styles.fieldWrapper}>
                  <label htmlFor={`fileTypeEdit-${props.subproject.id}`} className={styles.fieldWrapper_imageMask}></label>
                  <input
                    className={styles.inputFile}
                    id={`fileTypeEdit-${props.subproject.id}`}
                    name='fileTypeEdit'
                    type='file'
                    accept='.pdf, .xlsx, .xls'
                    onChange={(event) => {
                      if (event.currentTarget.files[0]) {
                        setFieldValue("file", event.currentTarget.files[0]);
                        fileNameHandler(event.currentTarget.files[0].name);
                      }
                    }}
                    style={{ display: "none" }}
                  />
                  <input type='text' id='fileName' className={styles.itemInfo_input} placeholder={placeholderFile || file.name} value={fileName} />
                </div>
                <div style={{ display: 'block', position: 'relative' }}>
                </div>
                <div className={styles.fieldWrapper_buttonContainer}>
                  <button type='button' className={styles.buttonCambios_cancelar} onClick={() => openHandler(!open)}>
                    <Trash />
                    Cancelar
                  </button>
                  <button type='button' className={styles.buttonCambios} disabled={checkDisabled(initialValues, values)} onClick={() => { editHandler(values); }}>
                    Guardar Cambios
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        ) : null}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    postulationProject: state.dashboard.postulationProject,
    subProjectSubId: state.profile.sendSubprojects.subProyectoListId,
    subProjectEdit: state.profile.subProjectId,
    subProjectId: state.profile.subProjectId?.id,
    projectIdForSub: state.profile.subProjectId?.proyecto || state.profile.projectIdForSub,
    projectToEditId: state.profile.projectToEdit.id,
    subProjectsToEdit: state.profile.projectToEdit.subproyecto,
  };
};

export default connect(mapStateToProps, {
  deleteSubProjects,
  setEditSendSubProject,
  updateSubProject,
  updateSubCotizacion,
})(SubProyectoItem);
